import { useMemo } from 'react';
import { displayNameToInitials, maybeGetANameOutOfEmailAddress } from '../../lib/displayUtils';
import SVGTextStyle from '../baseStyledComponents/SVGTextStyle';
import { ContactSvg } from '../defaultSvgIcons/ContactSvg';
import SVGWrapper from './SVGWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const AvatarContactInitials = ({
  displayName,
  size
}) => {
  const content = useMemo(() => {
    if (!displayName) {
      return undefined;
    }
    return displayNameToInitials(displayName) || maybeGetANameOutOfEmailAddress(displayName);
  }, [displayName]);
  if (!content) {
    return /*#__PURE__*/_jsx(ContactSvg, {});
  }
  return /*#__PURE__*/_jsx(SVGWrapper, {
    size: size,
    children: /*#__PURE__*/_jsx(SVGTextStyle, {
      y: "55",
      children: content
    })
  });
};